import React, { useCallback, useContext, useMemo, useState } from 'react';
import useTranslations from '../../hooks/useTranslations';
import { UPDATE_FORM } from '../../store/modules/state/formBuilder';
import FormBuilderCustomizationView from '../view/FormBuilderCustomizationView';
import { FormBuilderContext } from './FormBuilderEngine';

const getMessageFromForm = form =>
  (form.postSubmitMsgs &&
    form.postSubmitMsgs.default &&
    form.postSubmitMsgs.default.text) ||
  'forms.thanks.submitted';

const FormBuilderCustomizationEngine = () => {
  const { form, autosave } = useContext(FormBuilderContext);
  const t = useTranslations();
  const [message, setMessage] = useState(t(getMessageFromForm(form)));
  const [open, setOpen] = useState(false);

  const onSaveBtnClicked = useCallback(() => {
    const payload = {
      ...form
    };
    if (form.postSubmitMsgs && form.postSubmitMsgs.default) {
      payload.postSubmitMsgs.default.text = message;
    } else {
      payload.postSubmitMsgs = {
        default: {
          text: message
        }
      };
    }
    autosave({
      type: UPDATE_FORM,
      payload,
      callback: () => {
        openSnackbar('success', 'automation.snackbar.success.general');
      }
    });
  }, [form, message]);

  const additionalPlaceholders = useMemo(() => {
    return [
      {
        value: 'referenceId',
        text: 'Reference ID'
      }
    ];
  }, []);

  const viewProps = {
    onSaveBtnClicked,
    setMessage,
    setOpen,
    message,
    open,
    additionalPlaceholders
  };

  return <FormBuilderCustomizationView {...viewProps} />;
};

export default FormBuilderCustomizationEngine;
